import { Component, OnInit, Input, AfterContentInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
/* Validators */
import { EmailValidator } from 'src/app/validators/email/email-validator';
import { PasswordValidator } from 'src/app/validators/password/password-validator';
import { NotAdultValidator } from 'src/app/validators/notadult/notadult-validator';
/* Models */
import { RegisterUserModel, RegisterErrorModel } from 'src/app/models/registeruser.model';
import { Country, State } from 'src/app/models/userdetails.model';
/* Templates */
import { TerminsOfServiceTemplateSheetComponent } from 'src/app/tools/templatesheets/terms-of-service-template-sheet/terms-of-service-template-sheet.component';
import { TerminsAndConditionsTemplateSheetComponent } from 'src/app/tools/templatesheets/termins-and-conditions-template-sheet/termins-and-conditions-template-sheet.component';
import { PrivatePolicyTemplateSheetComponent } from 'src/app/tools/templatesheets/private-policy-template-sheet/private-policy-template-sheet.component';
/* Material */
import { MatBottomSheet } from '@angular/material/bottom-sheet';
/* Packages */
import { Subscription, Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
/* Services */
import { AuthService } from 'src/app/services/auth/auth.service';
import { ClientService } from 'src/app/services/client/client.service';
import { UserService } from 'src/app/services/user/user.service';
import { LottosService } from 'src/app/services/lottos/lottos.service';
import { DialcodeService } from 'src/app/services/dialcode/dialcode.service';
import { StateService } from 'src/app/services/state/state.service';
import { SignonService } from 'src/app/services/signon/signon.service';
/* Global configs */
import { environment } from 'src/environments/environment';
import { RedirectToMainSiteService } from 'src/app/services/redirectToMainSite/redirect-to-main-site.service';
import { StoragePermissionService } from 'src/app/services/storagePermission/storage-permission.service';
import { Router } from '@angular/router';
import { WindorefService } from 'src/app/services/window/windoref.service';
import { Language } from '../language/language';
import { MatDialog } from '@angular/material/dialog';
import { ModalAcceptsTermsComponent } from 'src/app/components/modal-accepts-terms/modal-accepts-terms.component';

/* Todo: integrate this with Abstract Controls */
const EMAIL_REGEXP: any = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})$/;
const accentedCharacters = 'àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ';
const stringRegex = '^[a-zA-Z' + accentedCharacters + '\\s]+$';

@Component({
  selector: 'app-login',
  templateUrl: './login.component' + AuthService.multisite.view + '.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterContentInit {
  @Input() state: boolean;
  registerForm: FormGroup;

  /* Animation Variables */
  showForm: boolean = true;
  signInUpText: string;
  signInUpState: boolean;
  isHide: boolean = true;
  forgotPass: boolean = false;
  isStep: boolean = false;
  loading: boolean = false;

  /* Error Variables */
  error: boolean = false;
  errorMailExist: boolean;
  errorFormInvalid: boolean = false;
  errorCredentials: boolean;
  errorRecovery: boolean;
  errorCpfInvalid: boolean;
  errorNumberPhone: boolean;
  errorInvalidState: boolean;

  /* Country & State Variables */
  countries: Country[] = [];
  country: Country = null;
  filteredCountries: Observable<Country[]>;
  arrCountries: any;
  dialcode: any = { isValid: false };
  states: State[] = [];
  filteredStates: Observable<State[]>;
  showState: boolean = false;

  /* Lotto Variables */
  lottoSubs: Subscription;

  /* General Variables */
  title: string;
  sys: string;
  user: RegisterUserModel;
  lottoId = environment.lottery.lot_id;
  isSubmit = false;
  acceptTerms = false;
  public lang: any = Language.currentLanguage.lenid;

  constructor(
    private _sheet: MatBottomSheet,
    private formBuilder: FormBuilder,
    private clientService: ClientService,
    private dialcodeService: DialcodeService,
    private lotto: LottosService,
    private _state: StateService,
    private _user: UserService,
    private _signOnService: SignonService,
    private redirectSrv: RedirectToMainSiteService,
    private _storageService: StoragePermissionService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.buildForm();
    this.setSysAndLang();
  }

  ngAfterContentInit(): void {
    this.clientService.getCountries().subscribe((countries: any) => (this.countries = countries.data));
    this.filterCountry();
    this.dialcodeService.getDialcode();
  }

  setSysAndLang(): void {
    this.lottoSubs = this.lotto.lottoObservable$.subscribe((lottoObj) => {
      this.sys = lottoObj['system'];
    });
  }

  buildForm() {
    this.registerForm = this.formBuilder.group(
      {
        email: new FormControl('', [Validators.email, Validators.required, Validators.pattern(EMAIL_REGEXP)]),
        password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern('[a-zA-Z0-9]+'), Validators.maxLength(16)]),
        name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.pattern('^[a-zA-Z]+$'), Validators.maxLength(16)]),
        last_name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.pattern('[a-zA-Z ]+'), Validators.maxLength(16)]),
        phone: new FormControl('', [Validators.pattern('[0-9]+'), Validators.maxLength(15)]),
        country: new FormControl(null, [Validators.pattern(stringRegex)]),
        address1: new FormControl(null, [Validators.required]),
        birthdate: new FormControl(null, [Validators.required]),
        ssn: new FormControl(null)
      },
      {
        validator: [NotAdultValidator.NotAdult]
      }
    );
  }

  registerUser(): void {
    if(!this.acceptTerms){
      this.openModalInformation();
    }else{
      this.loading = true;
      let data = this.registerForm.value;
      if (this.country?.iso !== 'CO' && this.country?.iso !== 'BR') {
        const dataBasic = {
          email: this.registerForm.get('email').value,
          password: this.registerForm.get('password').value,
          name: this.registerForm.get('name').value,
          last_name: this.registerForm.get('last_name').value,
          phone: this.registerForm.get('phone').value,
          country: this.registerForm.get('country').value,
          birthdate: this.registerForm.get('birthdate').value,
          address1: this.registerForm.get('address1').value
        };
        if (this.showState) {
          data = {
            state: this.registerForm.get('state').value,
            ...dataBasic
          };
        } else {
          data = {
            ...dataBasic
          };
        }
      }

      this.user = this._user.getUserData(data, this.getCallCode(), this.getCountryID(), this.getStateID());
      if (this.registerForm.valid) {
        this.makeResgisterUser();
      } else {
        this.loading = !this.loading;
        this.errorFormInvalid = true;
      }
    }

  }

  openModalInformation(): void {
    this.dialog.open(ModalAcceptsTermsComponent, {
      disableClose: true,
      width: '450px',
      data: { id: 0 }
    });
  }

  getCountryID(): number {
    let country: string = this.registerForm.get('country').value;

    return this.countries.find((c) => c.name.toLowerCase() == this.removeAccents(country))?.identifier;
  }

  getStateID(): number {
    if (!this._state.countryHasState()) return 0;

    let state: string = this.registerForm.get('state').value;
    return this.states.find((s) => this.removeAccents(s.name) === this.removeAccents(state))?.identifier;
  }

  getCallCode(): string {
    return this.dialcode.callingCodes ? this.dialcode.callingCodes[0] : 0;
  }

  getCountry(country = null) {
    if (country) {
      this.country = country;
    } else {
      let country: string = this.registerForm.get('country').value;
      this.country = this.countries.find((c) => c.name.toLowerCase() === this.removeAccents(country));
    }
    if (this.country) {
      const formControl = this.registerForm.get('ssn');
      if (this.country?.iso === 'CO' || this.country?.iso === 'BR') {
        this.registerForm.controls['ssn'].setValidators(Validators.required);
      } else {
        if (formControl) {
          this.registerForm.controls['ssn'].clearValidators();
        }
      }
    }
  }

  changeStep($event: any) {
    if (
      this.registerForm.controls['name'].invalid ||
      this.registerForm.controls['email'].invalid ||
      this.registerForm.controls['password'].invalid ||
      this.registerForm.controls['country'].invalid ||
      this.registerForm.controls['birthdate'].invalid ||
      this.registerForm.controls['phone'].invalid ||
      this.registerForm.controls['address1'].invalid ||
      (this.country && (this.country?.iso === 'CO' || this.country?.iso === 'BR') && this.registerForm.controls['ssn'].invalid)
    ) {
      this.error = true;
    } else {
      $event.preventDefault();
      this.resetFlats()
      this.error = false;
      this.isStep = !this.isStep;
      this.registerUser();
    }
  }

  get setTitle() {
    return this.state ? (this.title = 'LOGIN.PLACEHOLDER.WELCOMEBACK') : (this.title = 'LOGIN.PLACEHOLDER.WELCOMESINGUP');
  }

  showPassword(): void {
    this.isHide = !this.isHide;
  }

  changeState($event: any): void {
    $event.preventDefault();
    this.state = !this.state;
  }

  filterCountry() {
    this.filteredCountries = this.registerForm.get('country').valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );
  }

  private _filter(value: Country | string): Country[] {
    if (value && typeof value === 'object') {
      const filterValue = value.name.toLowerCase();
      return this.countries.filter((country) => country.name.toLowerCase().includes(filterValue));
    }
    if (value && typeof value === 'string') {
      const filterValue = value.toLowerCase();
      return this.countries.filter((country) => country.name.toLowerCase().includes(filterValue));
    }
    if (value === '') {
      return this.countries;
    }
  }

  filterState() {
    if (this._availableCountry) {
      this.filteredStates = this.registerForm.get('state').valueChanges.pipe(
        startWith(''),
        map((value) => this._filterState(value))
      );
    }
  }

  onValidator(fieldTag: string, validatorTag: string) {
    const field = this.registerForm.controls[fieldTag];
    return field.errors && field.errors[validatorTag] && (this.isSubmit || field.touched);
  }

  private _filterState(value: State | string): State[] {
    if (value && typeof value == 'object') {
      const filterValue = value.name.toLowerCase();
      return this.states.filter((state) => state.name.toLowerCase().includes(filterValue));
    }
    if (value && typeof value == 'string') {
      const filterValue = value.toLowerCase();
      return this.states.filter((state) => state.name.toLowerCase().includes(filterValue));
    }
    if (value == '') {
      return this.states || [];
    }
  }

  setDialCode(): void {
    if (this._availableCountry()) {
      let country: string = this.registerForm.get('country').value;
      let countryISO = this.countries.find((c) => c.name.toLowerCase() == this.removeAccents(country))?.iso;
      this.dialcodeService.setDialCode(countryISO);
      this.dialcodeService.dialCodeObservable$.subscribe((res: any) => {
        if (typeof res === 'object') {
          this.dialcode = { ...res, isValid: true };
        }
      });
    }
  }

  countryControls(): void {
    // this._checkStateValue();
    if (this._availableCountry()) {
      let country: string = this.registerForm.get('country').value;
      let countryCode = this.countries.find((c) => c.name.toLowerCase() === this.removeAccents(country))?.identifier;
      this._state.countryID = countryCode;
      if (this._state.countryHasState()) {
        this.registerForm.addControl('state', this.formBuilder.control('', [Validators.required, Validators.pattern(stringRegex)]));
        this.filterState();
        this._state.getStates().subscribe((res: any) => {
          this._showDataState(res.data);
        });
      } else {
        this._removeStateInput();
      }
    } else {
      this._removeStateInput();
    }
  }

  private _showDataState(data: any) {
    this.showState = true;
    this.states = [];
    this.states = data;
  }

  private _checkStateValue() {
    let state: any = this.registerForm.get('state');
    if (state != null) {
      let value = state.value;
      if (value != '') {
        state.reset();
      }
    }
  }

  private _removeStateInput() {
    let state: any = this.registerForm.get('state');
    this.showState = false;
    if (state != null) {
      this.registerForm.removeControl('state');
    }
  }

  openTerminsAndPolicy(typeOfSheet: number) {
    if (typeOfSheet === 1) {
      this._sheet.open(PrivatePolicyTemplateSheetComponent);
    }
    if (typeOfSheet === 2) {
      this._sheet.open(TerminsAndConditionsTemplateSheetComponent);
    }
    if (typeOfSheet === 3) {
      this._sheet.open(TerminsOfServiceTemplateSheetComponent);
    }
  }

  makeResgisterUser(): void {
    let { type } = environment;
    this._signOnService.user = this.user;
    switch (type) {
      case 'freeplay':
        this._signOnService.registerWithTempCart();
        break;
      case 'nxnoffer':
        this._signOnService.registerWithTempCart();
        break;
      case 'discount-product':
        this._signOnService.registerWithTempCart();
        break;
      case 'discount-vtemplate':
        this._signOnService.registerWithTempCart();
        break;
      case 'casino-freespin':
        this._signOnService.registerFreeSpins();
        break;
      case 'casino-deposit':
        this._signOnService.registerWithTempCart();
        break;
      default:
        console.warn('landing type unexpected');
        break;
    }

    this._signOnService.error$.subscribe((error: RegisterErrorModel) => {
      this.errorMailExist = error.errorMailExist;
      this.loading = error.loading;
      this.isStep = error.isStep;
      this.error = error.useSnackbar;
      this.errorCpfInvalid = error.cpfInvalid;
      this.errorNumberPhone = error.numberPhoneInvalid;
      this.errorInvalidState = error.invalidState;
    });
  }

  resetFlats():void{
    this.errorMailExist = false;
    this.errorCpfInvalid = false;
    this.errorNumberPhone = false;
    this.errorInvalidState = false;
  }

  removeAccents(input: string): string {
    return input
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  private _availableCountry(): boolean {
    let country: string = this.registerForm.get('country').value;
    let availableCountry = this.countries.find((row) => row.name.toLowerCase() === this.removeAccents(country));

    if (typeof availableCountry === 'object') {
      this.registerForm.get('country').setErrors({ MatchCountry: null });
      this.registerForm.get('country').updateValueAndValidity();
      return true;
    }
    this.registerForm.get('country').setErrors({ MatchCountry: true });
    return false;
  }

  redirectToLoginMain(): void {
    this.redirectSrv.redirectToLogin();
  }

  redirecToTerms(): void {
    let parentDomain = this._storageService.getDomainToRedirect();
    const url = `${parentDomain}/help/terms`;
    window.open(url, '_blank');
  }

  onCheckboxChange(e): void {
    this.acceptTerms = e.checked;
  }

  ngOnDestroy() {
    this.lottoSubs.unsubscribe();
  }
}
